{
  "required": "This field is required",
  "email": "Enter a valid email address",
  "minLength": "Must be at least {{count}} characters",
  "maxLength": "Must be at most {{count}} characters",
  "passwordWeak": "Password is too weak",
  "passwordsMismatch": "Passwords do not match",
  "invalidNumber": "Value must be a number",
  "tooManyDecimals": "At most five decimal places are allowed.",
  "positiveNumber": "Value must be greater than zero"
}
